"use client";
import ProductDto from '@/projectRoot/api-client/interfaces/models/products/Product.dto';
import style from './filtersSection.module.scss';
import { useEffect, useState } from 'react';
import { useGlobals } from '@/projectRoot/src/contexts/GlobalsContext';
import Container from '@/projectRoot/src/components/common/general/container/Container';
import Actions from '../actions/Actions';
import Product from '@/projectRoot/src/components/common/product/Product';
import Breadcrumbs, { BreadcrumbItem } from '@/projectRoot/src/components/common/breadcrumbs/Breadcrumbs';
import SimplePagination from '@/projectRoot/src/components/common/paginations/SimplePagination';
import Pagination from '@/projectRoot/src/components/common/paginations/Pagination';
import { useFilters } from '@/projectRoot/src/contexts/FiltersContext';

interface Props {
    title: string;
    description?: string;
    products: ProductDto[];
    breadcrumbs: BreadcrumbItem[];
}

export enum GridDisplay {
    ONE = 'one',
    TWO = 'two',
    FOUR = 'four'
}

const FiltersSection = ({title, description, products, breadcrumbs}: Props) => {
    const {isMobileView} = useGlobals();
    const {filters} = useFilters();
    const [gridDisplay, setGridDisplay] = useState<GridDisplay>(isMobileView ? GridDisplay.TWO : GridDisplay.FOUR); 
    const onChooseDisplay = (display: GridDisplay) => {
        setGridDisplay(display);
    }

    useEffect(() => {
        if(typeof window !== 'undefined'){
          let notifications = document.getElementById('header_notifications');
          let actions = document.getElementById('filters_actions');
          if(notifications && actions){
            actions.classList.add(`${style.notifications}`);
          }
        }
      }, []);

  return (
    <section className={style.filtersSection}>
        <Container>
            <div className={style.headPart}>
                <Breadcrumbs items={breadcrumbs} classes={[style.breadcrumbs]} />
                <h1 className={style.title}>
                    {title}
                </h1>
                {
                    description
                    ?
                    <p className={style.description}>
                        {description}
                    </p>
                    : <></>
                }
                {/* categories suggestions */}
            </div>
            <Actions 
                display={gridDisplay} 
                onChooseDisplay={onChooseDisplay} 
                classes={[style.actions]}
                products_length={products.length}
            />
            <div className={`${style.productsList} ${style[gridDisplay + 'Column']}`}>
                {
                    products.map(item => <Product key={item.id} product={item} classes={[style.product]} />)
                }
            </div>
            <SimplePagination pagination={filters.meta.paginator} />
            {/* <Pagination /> */}
        </Container>
    </section>
  )
};

export default FiltersSection;
